
<div mat-dialog-title>Threshold Exceeded for VSP Lots<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
    <mat-card class="block warn">
        <mat-card-title style="white-space: pre-line;">Due to downstream limitations, we cannot electronically submit more than 250 specific lots for any individual order. The following Sell orders will use your default lot depletion method instead.</mat-card-title>
    </mat-card>
    <div class="block">{{uniquePortfolios.length}} portfolio(s)</div>
    <div class="block">
      <irb-inventory-grid
              [style.width] = "'100%'"
              [style.height] = "'240px'"
              [showSideBar] = "false"
              [gridOptions] = "gridOptions"
              [frameworkComponents] = 'frameworkComponents'
              [rowData] = 'portfolios'
              (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="margin-top: 0 !important">
  <button (click)="close()" class="btn-medium-secondary">Close</button>
  <button (click)="proceed()" class="btn-medium-primary">Proceed</button>
</mat-dialog-actions>